import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import apiUrl from "../libs/baseUrl";

// Polls GET /notifications/unread-count for the navbar bell badge.
const POLL_INTERVAL_MS = 60000;

export default function useUnreadNotificationsCount() {
  const token = useSelector((state) => state.user.token);
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!token) return;
    try {
      const response = await axios.get(`${apiUrl}/notifications/unread-count`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (response.data?.status === "success") {
        setCount(response.data.data?.unread_count ?? 0);
      }
    } catch (err) {
      // Silent: the badge is non-critical chrome.
    }
  }, [token]);

  useEffect(() => {
    if (!token) return undefined;
    fetchCount();
    const timer = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [token, fetchCount]);

  return { count, refetch: fetchCount };
}
